import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=56ff104e&"
import script from "./Submissions.vue?vue&type=script&lang=ts&"
export * from "./Submissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports